var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnrichImg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 157,
    viewBox: "0 0 216 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.5,
    y: 23.5,
    width: 133,
    height: 133,
    rx: 66.5,
    fill: "white",
    stroke: "#E6E7EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 90C147.5 110.711 130.711 127.5 110 127.5C89.2893 127.5 72.5 110.711 72.5 90C72.5 69.2893 89.2893 52.5 110 52.5C130.711 52.5 147.5 69.2893 147.5 90Z",
    stroke: "#317BFF",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.25 78.75C121.25 84.9634 116.213 90 110 90C103.787 90 98.75 84.9634 98.75 78.75C98.75 72.5368 103.787 67.5 110 67.5C116.213 67.5 121.25 72.5368 121.25 78.75Z",
    stroke: "#317BFF",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.875 122.76C128.866 124.542 131.493 125.625 134.375 125.625C140.588 125.625 145.625 120.588 145.625 114.375C145.625 111.493 144.542 108.866 142.76 106.875",
    stroke: "#317BFF",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.125 122.76C91.1347 124.542 88.5063 125.625 85.625 125.625C79.4118 125.625 74.375 120.588 74.375 114.375C74.375 111.493 75.4582 108.866 77.2396 106.875",
    stroke: "#317BFF",
    strokeWidth: 6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110 112.5V105",
    stroke: "#317BFF",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M169.416 6.8916C169.51 7.2274 169.773 7.48971 170.108 7.58398L175.15 9L170.108 10.416C169.773 10.5103 169.51 10.7726 169.416 11.1084L168 16.1504L166.584 11.1084C166.49 10.7726 166.227 10.5103 165.892 10.416L160.85 9L165.892 7.58398C166.227 7.48971 166.49 7.2274 166.584 6.8916L168 1.84961L169.416 6.8916Z",
    fill: "#317BFF",
    stroke: "#317BFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6348 63.6729C11.729 64.0086 11.9914 64.271 12.3271 64.3652L18.1504 66L12.3271 67.6348C11.9914 67.729 11.729 67.9914 11.6348 68.3271L10 74.1504L8.36523 68.3271C8.27095 67.9914 8.00858 67.729 7.67285 67.6348L1.84961 66L7.67285 64.3652C8.00858 64.271 8.27095 64.0086 8.36523 63.6729L10 57.8496L11.6348 63.6729Z",
    fill: "#317BFF",
    stroke: "#317BFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M206.073 116.234C206.168 116.57 206.43 116.832 206.766 116.927L214.15 119L206.766 121.073C206.43 121.168 206.168 121.43 206.073 121.766L204 129.15L201.927 121.766C201.832 121.43 201.57 121.168 201.234 121.073L193.85 119L201.234 116.927C201.57 116.832 201.832 116.57 201.927 116.234L204 108.85L206.073 116.234Z",
    fill: "#317BFF",
    stroke: "#317BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrichImg2);
export default __webpack_public_path__ + "static/media/enrich-img2.5f22004f635f4732282ceff8b4886097.svg";
export { ForwardRef as ReactComponent };